import Layout from "../components/layout"
import SEO from "../components/seo"
import styled from "styled-components"
import React from "react"
import PageHero from "../components/PageHero"
import Family from "../images/family.jpg"
import HomeContact from "../components/HomeContact"
import Button from "../components/Button"
import PageLayout from "../components/PageLayout"





const AboutPage = () => (
  <Layout>
    <SEO title="About"/>
    <PageHero bg={Family} darkness={.3} h="50vh">

      <h2>About Air Service Experts</h2>

    </PageHero>

    <PageLayout>
      <h5>Air Service Experts</h5>
      <p>When your choosing a company for AC repair, heater repair, or anything HVAC related it is important to know
        what kind of company your trusting to enter your home.</p>

      <h5>25+ Years of Family</h5>
      <p>Air Service Experts is a family owned company and has been since we first opened 25 years ago. We are
        dedicated
        to providing your family only the best service as fast as possible because that is what our family here at
        Air
        Service Experts would want for our families. Our team members have their background checked and are
        thoroughly
        interviewed before we send them out on any service calls. With Air Service Experts on the case, you can rest
        easy knowing your AC or Heating System will be up in running in no time.</p>

      <h5>Quality First</h5>
      <p>Air Service Experts puts an emphasis on quality. From fixed a broken air conditioning unit to replacing a
        bad
        furnace our focus is on making sure we do the job right the first time. You shouldn't have to suffer the
        heat or
        the cold because a technician did a bad job! We use only the highest quality brand name parts to ensure your
        unit will continue to work for years to come.</p>

      <h5>Licensed & Experienced</h5>
      <p>All of technicians have their license and have been extensivly trained in almost every brand used in the
        United
        States. With Air Service Experts, you don't have to worry about someone failing to repair your heating or
        cooling system or even making the problem worse!</p>

      <h5>Low Cost</h5>
      <p>Unlike many of our competitors we don't overcharge for parts and labor. On the underhand we don't
        undercharge
        either! What do we mean? Simple! When someone comes to you and offers to do a $600 job for $200 and the part
        alone is $400, there is bound to be a problem! We don't take shortcuts and we do the job right using the
        right
        parts! On top of that we offer low cost financing for almost everyone with $0 down and no interest!</p>
    </PageLayout>



    <HomeContact/>

  </Layout>
)

export default AboutPage